import { __decorate } from "tslib";
import __NG_CLI_RESOURCE__0 from "./properties.component.html?ngResource";
import __NG_CLI_RESOURCE__1 from "./properties.component.scss?ngResource";
import { ChangeDetectionStrategy, ChangeDetectorRef, Component, ViewChild, ViewContainerRef } from "@angular/core";
import { TableSearchComponent } from "../../shared/components/table-search/table-search.component";
import { PropertyHeadingEnum, PropertySearchOption } from "./shared/models/property-heading.model";
import { PropertiesConstants } from "./properties.constants";
import _ from "underscore";
import { PropertySearchService } from "./shared/services/property-search.service";
import { ArcGisPropertyColumn } from "./shared/models/arcgis-property-column.model";
import { PropertiesSearchColumnToArcGisColumnOwnerLookup, PropertiesSearchColumnToArcGisColumnPropertyLookup, PropertiesSearchColumnToArcGisColumnSectionalTitleLookup, PropertiesSearchColumnToArcGisColumnZoningLookup } from "./shared/models/property-search-to-arcgis.model";
import { BusinessLicenceSearchEnum, OwnerSearchEnum, PropertySearchEnum, PropertyValuationSearchEnum, RateCertificateSearchEnum, ZoningSearchEnum } from "./shared/models/property-search-model";
import { headingToOwnerAttributeLookup, headingToPropertyAttributeLookup, headingToSectionalTitleAttributeLookup, headingToZoningAttributeLookup } from "./shared/models/heading-to-property-attribute.model";
import { BehaviorSubject } from "rxjs";
import { SharedConstants } from "../../shared/constants/shared.constants";
import { MapServiceService } from "../../core/settings/shared/map-service.service";
import { AppControllerService } from "../../app-controller.service";
import { RequestStatusService } from "../../shared/services/request-status/request-status.service";
import { PropertyService } from "./shared/services/property.service";
import { SearchTableService } from "../../shared/services/table-column-mapping/search-table.service";
import { SearchContainerHeight } from "../../shared/services/afla-module-strategy/afla-module-strategy.service";
import { SaveSearchService } from "../../shared/services/save-search/save-search.service";
import { ModuleConfigService } from "../../shared/services/module-config/module-config.service";
import { StrategyFinderComponent } from "../../shared/components/strategy-finder/strategy-finder.component";
import { AlertType } from "../../shared/models/alert";
import { Store } from "@ngrx/store";
import { AutoUnsub } from "../../shared/decorators/autounsub.decorator";
import { propertiesSearch } from "../../store/actions/tab-properties.actions";
let PropertiesComponent = class PropertiesComponent {
    propertySearchService;
    propertyService;
    mapService;
    appControllerService;
    changeDetectorRef;
    requestStatusService;
    searchTableService;
    saveSearchService;
    moduleConfigService;
    viewContainerRef;
    store;
    tableSearchFilterComponent;
    propertiesPageHeading = "";
    pageHeading = "";
    showSearchButton = true;
    propertyAttributeToTableColumn;
    filterOptions;
    selectedPropertySubject = new BehaviorSubject(undefined);
    selectedProperty;
    placeHolder;
    searchPlaceHolder;
    dataSource;
    isMapLoaded = false;
    parentComponent = "PropertiesComponent";
    preSelected;
    mapComponent;
    moduleHasZoningLookups = false;
    propertyList = [];
    getPropertyZoningSubscription;
    listenForSearchChangesSubscription;
    moduleHasChangedSubscription;
    propertiesSearchStoreDSSubscription;
    setMapLayerSubscription;
    mapLocationAsObservableSubscription;
    constructor(propertySearchService, propertyService, mapService, appControllerService, changeDetectorRef, requestStatusService, searchTableService, saveSearchService, moduleConfigService, viewContainerRef, store) {
        this.propertySearchService = propertySearchService;
        this.propertyService = propertyService;
        this.mapService = mapService;
        this.appControllerService = appControllerService;
        this.changeDetectorRef = changeDetectorRef;
        this.requestStatusService = requestStatusService;
        this.searchTableService = searchTableService;
        this.saveSearchService = saveSearchService;
        this.moduleConfigService = moduleConfigService;
        this.viewContainerRef = viewContainerRef;
        this.store = store;
    }
    ngOnInit() {
        const componentRef = this.viewContainerRef.createComponent(StrategyFinderComponent);
        const strategy = componentRef.instance.moduleStrategyService;
        this.propertiesPageHeading = strategy.propertiesPageHeading;
        this.pageHeading = strategy.propertiesPageHeading;
        this.placeHolder = SharedConstants.SEARCH_BY_DEFAULT;
        this.propertyList = [];
        this.dataSource = null;
        this.propertySearchService.clearTableColumnMap();
        this.propertySearchService.setTableColumnMap(headingToPropertyAttributeLookup);
        if (this.saveSearchService.getSavedDataResultsAsObservable())
            this.saveSearchService.clearSavedSearchResults();
        this.searchTableService.changeContainerHeight(SearchContainerHeight.PropertiesWithoutMap);
        this.propertyAttributeToTableColumn = headingToPropertyAttributeLookup;
        // need to check whether there are Zoning lookups before we add the Zoning to the search options
        this.getPropertyZoningSubscription = this.propertySearchService.getPropertyZoning(Number(this.appControllerService.selectedModuleID))
            .subscribe((lookups) => {
            this.moduleHasZoningLookups = lookups && lookups.value.length > 0;
            this.propertySearchService.zoningLookupList.next(lookups);
            if (lookups)
                this.propertyService.initializeAdvancedPropertySearchComponents();
            this.finaliseMapSettings();
        });
    }
    ngAfterViewInit() {
        this.listenForSelectedPropertyChange();
        this.listenForSearchChanges();
    }
    ngOnDestroy() {
        this.placeHolder = SharedConstants.SEARCH_BY_DEFAULT;
        this.propertyList = [];
        this.dataSource = null;
        this.saveSearchService.clearSavedSearchResults();
        this.propertySearchService.clearPropertyList();
        this.changeDetectorRef.detectChanges();
    }
    listenForSearchChanges() {
        this.listenForSearchChangesSubscription = this.propertySearchService.propertiesListAsObservable.subscribe((items) => {
            this.propertyList = items;
        });
    }
    mapLoaded() {
        this.isMapLoaded = true;
    }
    setHeadings() {
        switch (this.propertySearchService.searchType) {
            case PropertySearchOption.PropertyOwner:
                this.propertyAttributeToTableColumn = headingToOwnerAttributeLookup;
                break;
            case PropertySearchOption.PropertyZoning:
                this.propertyAttributeToTableColumn = headingToZoningAttributeLookup;
                break;
            case PropertySearchOption.Property:
                this.propertyAttributeToTableColumn = headingToPropertyAttributeLookup;
                break;
            case PropertySearchOption.SectionalTitle:
                this.propertyAttributeToTableColumn = headingToSectionalTitleAttributeLookup;
                break;
        }
        this.propertySearchService.setTableColumnMap(this.propertyAttributeToTableColumn);
        this.setFilterOptions();
        this.changeDetectorRef.detectChanges();
    }
    async handleSimpleSearch(search) {
        await this.searchProperties(search);
    }
    handleAdvancedSearch($event) {
        const selectedColumn = this.tableSearchFilterComponent.searchColumnComponent.selectedColumn;
        switch (selectedColumn) {
            case PropertySearchOption.SectionalTitle:
                this.propertySearchService.setSelectedSearchOption(PropertySearchOption.SectionalTitle);
                break;
            case PropertySearchOption.PropertyZoning:
                this.propertySearchService.setSelectedSearchOption(PropertySearchOption.PropertyZoning);
                break;
        }
        // if(this.moduleConfigService.isPropertyValuationModule()){
        //   this.propertySearchService.setSelectedSearchOption(PropertySearchOption.SectionalTitle);
        // } else{
        //   this.propertySearchService.setSelectedSearchOption(PropertySearchOption.PropertyZoning);
        // }
        this.setHeadings();
        this.dataSource = $event;
        this.changeDetectorRef.detectChanges();
    }
    async searchProperties(search) {
        if (search.column !== SharedConstants.SEARCH_BY_DEFAULT) {
            let flagModule;
            this.propertyList = [];
            this.propertySearchService.setPropertyList(this.propertyList);
            // @ts-ignore
            const column = this.getArcGISColumn(search.column);
            const url = this.propertySearchService.getLayerUrl(this.propertySearchService.searchType);
            const moduleHasChanged = this.store.select("modulesChanged");
            this.moduleHasChangedSubscription = moduleHasChanged.subscribe(mChanged => {
                flagModule = mChanged;
            });
            const propertiesSearchStoreDS = this.store.select("propertiesSearch");
            let propertiesSearchStore;
            if (propertiesSearchStore && !flagModule) {
                this.propertiesSearchStoreDSSubscription = propertiesSearchStoreDS.subscribe(pSearch => propertiesSearchStore = pSearch);
            }
            else {
                // @ts-ignore
                this.dataSource = await this.doPropertySearch(url, search.text, column);
                this.store.dispatch(propertiesSearch({ value: this.dataSource }));
            }
            this.changeDetectorRef.detectChanges();
        }
    }
    async doPropertySearch(url, searchText, column) {
        this.requestStatusService.showBusySpinner(SharedConstants.PROPERTY_SEARCH_STATUS);
        // @ts-ignore
        try {
            // @ts-ignore
            await this.propertySearchService.doSearch(url, searchText, column, false)
                .then((propertiesFound) => {
                if (propertiesFound.length > 0) {
                    this.propertySearchService.addMapLocatorLinks(propertiesFound);
                }
                else {
                    this.appControllerService.showMessage(`${SharedConstants.NO_ITEMS_AVAILABLE_MESSAGE} that matches your search term`, AlertType.Warning);
                }
                this.requestStatusService.removeBusySpinner(SharedConstants.PROPERTY_SEARCH_STATUS);
            });
        }
        catch (e) {
            this.requestStatusService.removeBusySpinner(SharedConstants.PROPERTY_SEARCH_STATUS);
        }
    }
    setMapLayer() {
        this.setMapLayerSubscription = this.mapService.layerUrlListAsObservable.subscribe((layers) => {
            if (layers) {
                this.propertySearchService.clearURLList();
                layers.forEach((layer) => {
                    if (layer.moduleId === Number(this.appControllerService.selectedModuleID))
                        this.propertySearchService.setURL(layer.layerType, layer.url);
                });
                this.setPropertySearchOptions();
            }
        });
    }
    propertySelected($event) {
        this.selectedPropertySubject.next($event);
    }
    exportTableClicked($event) {
        this.selectedPropertySubject.next($event);
    }
    showMap(show) {
        const divMapForProperties = document.getElementById("divMapForProperties");
        if (divMapForProperties) {
            if (show) {
                this.searchTableService.changeContainerHeight(SearchContainerHeight.PropertiesMap);
                this.changeDetectorRef.detectChanges();
                divMapForProperties.setAttribute("style", "display:block;");
            }
            else {
                this.searchTableService.changeContainerHeight(SearchContainerHeight.PropertiesWithoutMap);
                this.changeDetectorRef.detectChanges();
                divMapForProperties.setAttribute("style", "display: none !important;");
            }
            this.changeDetectorRef.detectChanges();
        }
    }
    finaliseMapSettings() {
        this.searchPlaceHolder = `${SharedConstants.SEARCH_PREFIX} ${this.pageHeading.toLocaleLowerCase()}`;
        this.setMapLayer();
        this.showMap(false);
    }
    setPropertySearchOptions() {
        const searchOptionList = [];
        if (this.moduleConfigService.isPropertyValuationModule())
            searchOptionList.push(..._.values(PropertyValuationSearchEnum));
        else if (this.moduleConfigService.isBusinessLicenceModule())
            searchOptionList.push(..._.values(BusinessLicenceSearchEnum));
        else if (this.moduleConfigService.isRatesCertificateModule())
            searchOptionList.push(..._.values(RateCertificateSearchEnum));
        else {
            searchOptionList.push(..._.values(PropertySearchEnum));
            if (this.propertySearchService.ownerUrl && this.propertySearchService.ownerUrl !== "")
                searchOptionList.push(..._.values(OwnerSearchEnum));
            // also need to check that there are Zoning lookups available for the Zoning drop-down
            if (this.moduleHasZoningLookups && this.propertySearchService.zoningUrl && this.propertySearchService.zoningUrl !== "")
                searchOptionList.push(..._.values(ZoningSearchEnum));
        }
        const propertyOptions = [];
        searchOptionList.forEach((option) => {
            if (propertyOptions.indexOf(option) < 0
                && option !== PropertyHeadingEnum.Cemetery) {
                propertyOptions.push(option);
            }
        });
        this.searchTableService.setPropertySearchOptions(propertyOptions);
        this.propertySearchService.setSearchOptionLookup(PropertySearchEnum);
        this.preSelected = PropertySearchEnum.ErfNumber;
        this.propertySearchService.setSelectedSearchOption(this.preSelected);
        this.searchTableService.setPreSelectedSearchOption(this.preSelected);
        this.selectedProperty = this.selectedPropertySubject.asObservable();
        this.setHeadings();
    }
    setFilterOptions() {
        this.filterOptions = new Array();
        this.filterOptions.push(SharedConstants.FILTER_BY_DEFAULT);
        this.filterOptions.push(..._.values(this.propertyAttributeToTableColumn.values()));
        this.changeDetectorRef.detectChanges();
    }
    getArcGISColumn(column) {
        this.propertySearchService.setSelectedSearchOption(column);
        this.setHeadings();
        switch (this.propertySearchService.searchType) {
            case PropertySearchOption.PropertyOwner:
                return PropertiesSearchColumnToArcGisColumnOwnerLookup.get(column);
            case PropertySearchOption.PropertyZoning:
                return PropertiesSearchColumnToArcGisColumnZoningLookup.get(column);
            case PropertySearchOption.Property:
                return PropertiesSearchColumnToArcGisColumnPropertyLookup.get(column);
            case PropertySearchOption.SectionalTitle:
                return PropertiesSearchColumnToArcGisColumnSectionalTitleLookup.get(column);
        }
    }
    listenForSelectedPropertyChange() {
        this.mapLocationAsObservableSubscription = this.propertySearchService.mapLocationAsObservable.subscribe((selectedPropertyId) => {
            if (selectedPropertyId && selectedPropertyId !== "") {
                this.viewSelectedPropertyOnMap(selectedPropertyId);
            }
        });
    }
    viewSelectedPropertyOnMap(propertyId) {
        const url = this.propertySearchService.getLayerUrl(PropertySearchOption.Property);
        this.requestStatusService.showBusySpinner(SharedConstants.PROPERTY_SEARCH_STATUS);
        // @ts-ignore
        this.propertySearchService.doSearch(url, propertyId, ArcGisPropertyColumn.Id, true, SharedConstants.SEARCH_BY_DEFAULT, true).then((result) => {
            if (result.length > 0) {
                this.setMapRoute(result);
            }
            this.requestStatusService.removeBusySpinner(SharedConstants.PROPERTY_SEARCH_STATUS);
        });
    }
    setMapRoute(properties) {
        if (this.isMapLoaded) {
            this.showMap(true);
            this.mapComponent.removeGraphicsFromMap(PropertiesConstants.SELECTED_PROPERTY_GRAPHICS_LAYER);
            const geometries = [];
            properties.forEach((property) => {
                geometries.push(property.geometry);
            });
            this.mapComponent.addGeometriesOnMap(geometries, PropertiesConstants.SELECTED_PROPERTY_GRAPHICS_LAYER);
            this.changeDetectorRef.detectChanges();
        }
    }
    static ctorParameters = () => [
        { type: PropertySearchService },
        { type: PropertyService },
        { type: MapServiceService },
        { type: AppControllerService },
        { type: ChangeDetectorRef },
        { type: RequestStatusService },
        { type: SearchTableService },
        { type: SaveSearchService },
        { type: ModuleConfigService },
        { type: ViewContainerRef },
        { type: Store }
    ];
    static propDecorators = {
        tableSearchFilterComponent: [{ type: ViewChild, args: [TableSearchComponent,] }],
        mapComponent: [{ type: ViewChild, args: ["esripropertiesmap", { static: true },] }]
    };
};
PropertiesComponent = __decorate([
    Component({
        standalone: false,
        selector: "app-properties",
        template: __NG_CLI_RESOURCE__0,
        changeDetection: ChangeDetectionStrategy.OnPush,
        styles: [__NG_CLI_RESOURCE__1]
    }),
    AutoUnsub()
], PropertiesComponent);
export { PropertiesComponent };
